export function normalizeSachetBarcode(value: string): string {
  return value.replace(/\s/g, '');
}

export function formatSachetBarcodeDisplay(value: string): string {
  const normalized = normalizeSachetBarcode(value);

  if (/^\d{13}$/.test(normalized)) {
    return `${normalized.slice(0, 4)} ${normalized.slice(4, 12)} ${normalized.slice(12)}`;
  }

  return value;
}
